 const API_BASE_URL = 'https://internet-activity-monitor.herokuapp.com/api/';
 const APP_KEY = 'bYOGBoXK3lPnajWf8f9my7Jbfu1QeVQN';
 const USER_ROLE_SUPER_ADMIN=1;
 const USER_ROLE_ADMIN=2;
 const USER_ROLE_SYSTEM_OPERATOR=3;
 const USER_ROLE_USER=4;

 const USER_ROLE_ALL = [1,2,3,4];
 const USER_ROLE_ALL_ADMIN = [1,2,3];

 //letter validation
 export function onKeyValidation(event) {
   let allowedCodes = [8,32,46,37,39];
   const char = String.fromCharCode(event.keyCode)
   let regex = /[^a-zA-Z, ]/;
   if(!allowedCodes.includes(event.keyCode) && regex.test(char)){
     event.preventDefault()
   }

   // alert(event.keyCode);
 }

 export default {
   API_BASE_URL,
   APP_KEY,
   USER_ROLE_SUPER_ADMIN,
   USER_ROLE_ADMIN,
   USER_ROLE_SYSTEM_OPERATOR,
   USER_ROLE_USER,
   USER_ROLE_ALL,
   USER_ROLE_ALL_ADMIN
 }




